import Grid from "@mui/material/Grid";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { styled as styling } from "@mui/material/styles";
import Color from "../../../assets/colors";
import WPTArrowIcon from "../../../assets/svg/wpt-arrow-icon.svg";

// Image Component //
export const ImageStyled = styling("img")({
  width: "5rem",
  height: "5rem",
  borderRadius: "0.625rem",
  objectFit: "contain",
});

// Grid Components //
export const OuterContainer = styling(Grid)((props) => ({
  width: "100%",
  height: "auto",
  backgroundColor: Color.homepageGrey,
  paddingTop: "88px",
  paddingInline: "100px",
  paddingBottom: "64px",
  marginTop: "0px",
  flexWrap: "nowrap",
  alignItems: "center",
}));

export const BlankContainer = styling(Grid)({
  marginTop: "10px",
});

export const DesktopContainer = styling(Grid)((props) => ({
  width: "100%",
  backgroundColor: Color.homepageGrey,
  maxWidth: "1240px",
  margin: "auto",
  position: "relative",

  [props.theme.breakpoints.between(1280, 1440)]: {
    maxWidth: "1080px",
  },
}));

export const TabletImageContainer = styling(Grid)((props) => ({
  width: "100%",
  maxWidth: "720px",
  margin: "auto",
  position: "relative",
  paddingBlock: "80px",
}));

export const MobileContainer = styling(Grid)({
  width: "100%",
  height: "100%",
  minHeight: "650px",

  marginBottom: "30px",

  backgroundColor: Color.homepageGrey,
});

export const WPTContainer = styling("div")((props) => ({
  position: "absolute",
  maxWidth: "160px",

  [props.theme.breakpoints.up(1440)]: {
    top: "24px",
    left: "24px",
  },

  [props.theme.breakpoints.between(1280, 1440)]: {
    maxWidth: "128px",
    top: "8px",
    left: "8px",
  },

  [props.theme.breakpoints.down(1280)]: {
    maxWidth: "122px",
    right: "32px",
    top: "24px",
  },
}));

export const SearchContainer = styling(Grid)((props) => ({
  height: "100%",
  minHeight: "200px",
  justifyContent: "center",

  [props.theme.breakpoints.down("tablet")]: {
    marginTop: "0px",
    paddingInline: "16px",
  },

  [props.theme.breakpoints.down("sm")]: {
    width: "328px",
    margin: "auto",
    paddingInline: "0",
  },
}));

export const LogoContainer = styling(Grid)((props) => ({
  height: "100%",
  width: "100%",
  justifyContent: props.isFirst
    ? "flex-end"
    : props.isSecond
    ? "flex-start"
    : "center",
  alignItems: "center",

  [props.theme.breakpoints.down(1280)]: {
    position: "relative",
  },
}));

export const MobileLogoContainer = styling(Grid)({
  height: "100%",
  width: "100%",
  justifyContent: "center",
  alignItems: "center",
  padding: "10px 15px 20px 15px",
  minHeight: "298px",
});

export const DesktopImageContainer = styling(Grid)({
  display: "flex",
  height: "100%",
  width: "auto",
  justifyContent: "center",
  alignItems: "center",
});

export const ImageContainer = styling(Grid)((props) => ({
  backgroundColor: Color.white,
  transitionDuration: "0.5s",
  transform: props.transform,
  height: "100px",
  width: "100px",
  opacity: props.opacity,
  borderRadius: "20px",
  zIndex: 1,
  right: props.right,

  ":hover": {
    cursor: "none",
  },

  [props.theme.breakpoints.down("lg")]: {
    transitionDuration: "2.5s",
  },

  [props.theme.breakpoints.down("tablet")]: {
    height: "80px !important",
    width: "80px !important",
  },
}));

export const CustomTooltip = styling(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    borderRadius: "20px",
    padding: "5px",
    border: "3px solid black",
    backgroundColor: Color.white,
    color: "black",
    zIndex: 5,
    cursor: "none",
  },
});

export const SearchInner = styling(Grid)({
  display: "flex",
  flexDirection: "column",
  rowGap: "16px",
  width: "100%",
});

// Typography Component //
export const CursorTypography = styling(Typography)({
  fontSize: "12px",
});

export const WPTTypography = styling(Typography)((props) => ({
  fontFamily: "Georgia",
  fontSize: "0.75rem",
  color: Color.black,
  lineHeight: "normal",
  textAlign: "end",

  [props.theme.breakpoints.down(1280)]: {
    textAlign: "start",
  },
}));

export const ResumeMsgTypography = styling(Typography)((props) => ({
  fontSize: "10px",
  color: "rgba(0, 0, 0, 0.60)",
  marginTop: "8px",
  fontFamily: "Inter",
  fontStyle: "italic",
  fontWeight: 400,
  letterSpacing: "0.15px",
  textAlign: "center",
}));

// Icon Component //
export const ArrowIcon = styling(WPTArrowIcon)((props) => ({
  position: "absolute",

  [props.theme.breakpoints.up(1440)]: {
    top: "80px",
    left: "128px",
  },

  [props.theme.breakpoints.between(1280, 1440)]: {
    top: "72px",
    left: "96px",
  },

  [props.theme.breakpoints.down(1280)]: {
    transform: "rotateY(3.142rad)",
    top: "88px",
    right: "104px",
  },
}));

export const JWCContainer = styling("div")((props) => ({
  position: "absolute",
  maxWidth: "160px",

  [props.theme.breakpoints.up(1440)]: {
    top: "10px",
    right: "24px",
  },

  [props.theme.breakpoints.between(1280, 1440)]: {
    maxWidth: "150px",
    top: "2px",
    right: "8px",
  },

  [props.theme.breakpoints.down(1280)]: {
    maxWidth: "150px",
    left: "35px",
    bottom: "35px",
  },
}));

// Icon Component //
export const RightArrowIcon = styling(WPTArrowIcon)((props) => ({
  position: "absolute",
  transform: "rotateY(3.142rad)",

  [props.theme.breakpoints.up(1440)]: {
    top: "50px",
    right: "128px",
  },

  [props.theme.breakpoints.between(1280, 1440)]: {
    top: "50px",
    right: "96px",
  },

  [props.theme.breakpoints.down(1280)]: {
    bottom: "40px",
    left: "180px",
    transform: "rotate(290deg)",
  },
}));
